export type InvoicingSystem = 'quickBooks' | 'synkedUp'

export type InvoicingSettings = {
  invoicingSystem: InvoicingSystem
  hideApprovedApplication: boolean
  defaultPaymentMethods : DefaultPaymentMethods
  defaultAuthorizationForPaymentOnFile: DefaultAuthorizationForPaymentOnFile
  defaultLineItemGrouping: DefaultLineItemGrouping
  invoicingAddress: InvoicingAddress
  supportEmail: string
  defaultDueInDays: number
  qboDepositBankAccountId: string | null
  qboFeesExpenseAccountId: string | null
  automaticTaxIsDefault: boolean
  automaticTaxIsActive: boolean
  defaultIncludePaymentSummary: boolean
}

export type DefaultPaymentMethods = {
  ach: boolean
  creditCard: boolean
}

export type DefaultAuthorizationForPaymentOnFile = {
  showAuthorizePaymentOnFile: boolean
  requireAuthorizePaymentOnFile: boolean
}

export const defaultInvoicingSettings = (): InvoicingSettings => ({
  invoicingSystem: 'quickBooks',
  hideApprovedApplication: false,
  defaultPaymentMethods: {
    ach: false,
    creditCard: false
  },
  defaultAuthorizationForPaymentOnFile: {
    showAuthorizePaymentOnFile: false,
    requireAuthorizePaymentOnFile: false
  },
  defaultLineItemGrouping: {
    project: 'perWorkarea',
    maintenance: 'perWorkarea',
    serviceTicket: 'perWorkarea'
  },
  invoicingAddress: {
    address1: '',
    city: '',
    state: '',
    zip: '',
    countryCode: ''
  },
  supportEmail: '',
  defaultDueInDays: 0,
  qboDepositBankAccountId: null,
  qboFeesExpenseAccountId: null,
  automaticTaxIsDefault: false,
  automaticTaxIsActive: true,
  defaultIncludePaymentSummary: true
})

export type InvoicingSystemSettings = {
  invoicingSystem: InvoicingSystem
  defaultPaymentMethods : DefaultPaymentMethods
  defaultAuthorizationForPaymentOnFile: DefaultAuthorizationForPaymentOnFile
  qboDepositBankAccountId: string | null
  qboFeesExpenseAccountId: string | null
}

export type DefaultLineItemGrouping = {
  project: LineItemGroupingOption
  maintenance: LineItemGroupingOption
  serviceTicket: LineItemGroupingOption
}

export type InvoicingAddress = {
  address1: string
  city: string
  state: string
  zip: string
  countryCode: string
}

export type LineItemGroupingOption = 'perWorkarea' | 'perWorkareaAndVisit' | 'perWorkareaItem' | 'perGroup'

export type GeneralInvoicingSettings = {
  invoicingAddress: InvoicingAddress
  supportEmail: string
  defaultDueInDays: number
}

export type QboAccountFieldErrors = {
  qboDepositBankAccountId?: string
  qboFeesExpenseAccountId?: string
}

const QBO_DEPOSIT_BANK_FIELD = 'QboDepositBankAccountId'
const QBO_FEES_EXPENSE_FIELD = 'QboFeesExpenseAccountId'

export const parseQboAccountFieldErrors = (errors: string[]): QboAccountFieldErrors => {
  const result: QboAccountFieldErrors = {}
  for (const error of errors) {
    if (error.startsWith(QBO_DEPOSIT_BANK_FIELD)) {
      result.qboDepositBankAccountId = error
    } else if (error.startsWith(QBO_FEES_EXPENSE_FIELD)) {
      result.qboFeesExpenseAccountId = error
    }
  }
  return result
}
